<template>
  <v-app>

  <v-toolbar 
    color="secondary"
    v-if="isAdmin"
    dark 
    fixed  
    dense 
    app
    clipped-right>
    
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
        <v-btn 
          v-on="on"
          :to="{path: '/'}" 
          icon>
          <v-icon>map</v-icon>
        </v-btn>
        </template>
        <span>Map</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            :to="{name: 'edit'}" 
            icon>
            <v-icon>add</v-icon>
          </v-btn>
        </template>
      <span>Add New</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn 
            v-on="on"
            :to="{name: 'settings'}" 
            icon>
            <v-icon>settings</v-icon>
          </v-btn>
        </template>
      <span>Settings</span>
      </v-tooltip>

     <v-tooltip bottom>
       <template v-slot:activator="{ on }">
        <v-btn 
            v-on="on"
            :to="{name: 'reports'}" 
            icon>
            <v-icon>insert_chart</v-icon>
          </v-btn>
       </template>
      <span>Reports</span>
     </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" href="/logout.php" icon>
            <v-icon>power_settings_new</v-icon>
          </v-btn>
        </template>
      <span>Logout</span>
      </v-tooltip>

       <v-toolbar-title class="white--text">{{ siteName }} Admin</v-toolbar-title>
       <v-spacer></v-spacer>
       <div style="width: 300px;">
      <v-menu
        ref="dateMenu"
        v-model="dateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="date"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px">
        <template v-slot:activator="{ on }">
          
          <v-text-field
            v-model="date"
            prepend-icon="event"
            readonly
            v-on="on">
          </v-text-field>
        </template>
        <v-date-picker v-model="date" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="dateMenu = false">Cancel</v-btn>
          <v-btn flat color="primary" @click="setDate">OK</v-btn>
        </v-date-picker>
      </v-menu>
      </div>
    </v-toolbar>
   <keep-alive include="HomeView">
    <router-view></router-view>
   </keep-alive>
    <v-footer color="black" app>
      <v-btn dark color="back" href="http://www.itsgeek2me.net" target="_blank">Powered by: It's Geek to Me</v-btn>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  mounted() {
  },
  data () {
    return {
      dateMenu: false,
    }
  },
methods: {
  setDate() {
     this.$refs.dateMenu.save(this.date);
     window.location.href = '/index.php?date=' + this.date;
  }
},
computed: {
     getSiteTitle() {
       if (this.siteTitle) {
         return this.siteTitle
       }
       return this.siteName + ' Open House Directory';
     },
     mapdrawer: {
        get() {
          return this.$store.state.mapdrawer;
        },
        set(value) {
          this.$store.commit("set_mapdrawer", value);
        }
      },      
      properties: {
        get() {
          return this.$store.state.properties;
        },
        set(value) {
          this.$store.commit("set_properties", value);
        }
      },
      isAdmin: {
        get() {
          return this.$store.state.isAdmin;
        },
        set(value) {
          this.$store.commit("set_isAdmin", value);
        }
      },
      siteTitle: {
        get() {
          return this.$store.state.siteTitle;
        },
        set(value) {
          this.$store.commit("set_siteTitle", value);
        }
      },
      siteName: {
        get() {
          return this.$store.state.siteName;
        },
        set(value) {
          this.$store.commit("set_siteName", value);
        }
      },
      date: {
        get() {
          return this.$store.state.reportDate;
        },
        set(value) {
          this.$store.commit("set_reportDate", value);
        }
      },
    },
    watch: {
    }

}
</script>
